import React, { Component } from "react";
import { SwatchesPicker } from 'react-color';

class WallColor extends Component {

	onChangeComplete = (color) => {
		this.props.dispatch({
			type: 'SET_STATE',
			state: {
				wallcolor: color.hex
			}
		})
    };

 	render() {
	    return (
			<div className="row">
				<div className="col-sm-12">
					<SwatchesPicker
				        color={this.props.wallcolor}
				        onChangeComplete={this.onChangeComplete} />
				</div>
			</div>
	    );
  	}
}
 
export default WallColor;